import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {
  downloadMOM,
  getAgendaWithMinutesDetails,
} from "../../redux/actions/meetingActions/MeetingAction";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import LoaderButton from "../Common/LoaderButton";
import MeetingActivities from "../Meeting/MeetingActivities";
import ViewMinutes from "./ViewMinutes";
import MeetingAttendance from "../Meeting/MeetingAttendance";
import ViewParentActions from "./ViewParentActions";
import MOMAcceptanceDetails from "./MOMAcceptanceDetails";
import { logOut } from "../../redux/actions/authActions/authAction";
import MeetingDropDown from "../Meeting/MeetingDropDown";
import BackButton from "../Common/Backbutton";
import SmallLoaderButton from "../Common/SmallLoaderButton";
import {
  acceptMOM,
  processAmendmentRequest,
  setSuccess,
  updateAmendmentRequest,
} from "../../redux/actions/minuteActions/MinuteAction";
import { toast } from "react-toastify";
const ViewMinutePage = (props) => {
  let { meetingId } = useParams();

  const accessToken = localStorage.getItem("accessToken");
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }

  const [isLoading, setIsLoading] = useState(false);
  const employeeData = useSelector((state) => state.user);
  const minuteData = useSelector((state) => state.minute);
  const meetingData = useSelector((state) => state.meeting);
  const [isAccepted, setIsAccepted] = useState(false);
  useEffect(() => {
    document.title = "View Minutes: MinutesVault";
    if (meetingId && accessToken) {
      dispatch(getAgendaWithMinutesDetails(meetingId, accessToken));
    }
    return () => { };
  }, []);

  const isMeetingOrganiser =
    meetingData?.meetingDetails?.createdById?.toString() ===
      employeeData?.userData?._id?.toString()
      ? true
      : false;
  const processDownloadMOM = async () => {
    setIsLoading(true);
    await dispatch(downloadMOM(meetingId, accessToken));
    setIsLoading(false);
  };


  const isMomAccepted =
    meetingData?.meetingDetails?.momAcceptDetails?.length > 0 &&
      meetingData?.meetingDetails?.momAcceptDetails?.find(
        (user) =>
          user?.userId?.toString() == employeeData?.userData?._id?.toString()
      )
      ? true
      : false;

  const momId =
    meetingData?.meetingDetails?.momGenerationDetails?.length !== 0
      ? meetingData?.meetingDetails?.momGenerationDetails[
        meetingData?.meetingDetails?.momGenerationDetails?.length - 1
      ]?.momId
      : null;
  const acceptMOMData = (meetingId) => {
    if (isAccepted) {
      dispatch(acceptMOM(meetingId, { momId }, accessToken));
    } else {
      toast.warning("Please accept MOM condition.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <>
      {meetingData?.meetingDetails !== null ? (
        <div className="main-content">
          <div className="page-heading d-flex justify-content-between align-items-center mb-0">
            <div className="meeting-header-text line-height-h4">
              {meetingId ? <h4>MOM Details</h4> : <h4>MOM Preview</h4>}
            </div>
            <div className="agenda-btn-icon screen-hide-380">
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  type="button"
                  id="open-form-btn"
                  className="Mom-btn btn btn-primary filter-height"
                  onClick={() => {
                    processDownloadMOM();
                  }}
                >
                  <p>Download MOM</p>
                </button>
              )}

              <div className="d-inline-block menu-dropdown custom-dropdown">
                <div className="dropdown">
                  <div className="d-inline-block menu-dropdown custom-dropdown">
                    {meetingData?.meetingDetails && (
                      <div className="d-inline-block menu-dropdown custom-dropdown inner-mt">
                        <div className="d-inline-block menu-dropdown custom-dropdown">
                          <Dropdown>
                            <MeetingDropDown
                              meetingDetails={meetingData?.meetingDetails}
                              meetingId={meetingData?.meetingDetails?._id}
                              status={
                                meetingData?.meetingDetails?.meetingStatus
                                  ?.status
                              }
                            />
                          </Dropdown>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <BackButton show={camefromPreviousPage} />
            </div>
          </div>

          <div className="row">
            <>
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
                <ViewMinutes meetingId={meetingId} />
                {meetingData?.meetingDetails?.parentMeetingId ? (
                  <form className="mt-4">
                    <ViewParentActions
                      parentMeetingId={
                        meetingData?.meetingDetails?.parentMeetingId
                      }
                      childMeetingId={meetingData?.meetingDetails?._id}
                      isHideOptions={true}
                    />
                  </form>
                ) : null}
              </div>

              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col res-mt-20 mt-0">
                <div className="d-flex flex-column">
                  <form className="mt-4 mt-md-2 details-form details-form-right order-3 order-md-1 box-rightside-attendance">
                    <MeetingAttendance />
                  </form>
                  {minuteData ? (
                    <form className="mt-4 details-form details-form-right order-2 order-md-2">
                      <MOMAcceptanceDetails meetingId={meetingId} />
                    </form>
                  ) : null}

                  {isMeetingOrganiser || employeeData.userData.isAdmin ? (
                    <form className="mt-4 details-form details-form-right order-1 order-md-3">
                      <MeetingActivities meetingId={meetingId} />
                    </form>
                  ) : null}

                   <form className="mt-4 details-form details-form-right order-4 order-md-4 acceptance-mom">
                      <div>
                        {meetingData?.meetingDetails?.attendees?.length !== 0 &&
                          !meetingData?.meetingDetails?.attendees.find(
                            (attendee) =>
                              attendee._id.toString() ===
                              employeeData?.userData?._id?.toString()
                          ) ? null : (
                          <>
                       
                            {meetingId && isMomAccepted === false ? (
                              <div className="mom-acceptance ">
                                <div className="meeting-organiser d-flex">
                                  <input
                                    type="checkbox"
                                    name="isAccepted"
                                    checked={isAccepted}
                                    onChange={() => {
                                      setIsAccepted(!isAccepted);
                                    }}
                                  />
                                  <span>
                                    By acknowledging this Minutes of Meeting (MOM), you
                                    confirm the accuracy and completeness of the
                                    discussions and agreements recorded herein.{" "}
                                  </span>
                                </div>
                                <div className="clearfix"></div>
                                <button
                                  className="add-minutes Mom-btn mt-2 accept-mom-btn"
                                  type="button"
                                  onClick={(e) => {
                                    acceptMOMData(meetingData.meetingDetails._id);
                                  }}
                                >
                                  <p>I Accept the MOM</p>
                                </button>
                              </div>
                            ) : meetingId && isMomAccepted ? (
                              <div className="mom-acceptance meeting-organiser d-flex align-items-center w-auto-margin18">
                                <button
                                  className="add-minutes Mom-btn mt-2"
                                  type="button"
                                >
                                  <p>MOM Accepted</p>
                                </button>
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>

                    </form>


                </div>
              </div>
            </>
          </div>
        </div>
      ) : meetingData?.meetingDetails === null &&
        !meetingData.loading &&
        !meetingData.isSuccess ? (
        <div className="main-content">
          <div className="row">
            <NoDataFound />
          </div>
        </div>
      ) : (
        <div>
          <Loader />
        </div>
      )}







    </>
  );
};

export default ViewMinutePage;
